import { ISiteUserInfo } from '../../ts/models/ISiteUserInfo';
import { FeatureFlags } from '../../ts/FeatureFlags';
import React = require('react');
import { Formik, FormikProps } from 'formik';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { Messages } from '../../codegen/Localize';
import { FormikCheckbox } from '../../commonInfra/components/FormikCheckbox';
import _ = require('underscore');
import { InlineCancelAndSaveButtons } from './UserSettingEditButtons';
import { UserSettings } from '../services/resources/UserSettings';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';
import { IError } from '../../httpClient/serverApi/types/IError';
import { IServerUserInfo } from '../../ts/models/IServerUserInfo';

export type MarkAnimationProps = {
    userHasNoSiteId: boolean;
    siteUser: ISiteUserInfo;
    serverUser: IServerUserInfo;
}

export interface MarkAnimationField {
    markAnimationSetting: boolean;
}

function showButtons(formik: FormikProps<MarkAnimationField>, markAnimationSetting: boolean) {
  if (!formik.touched || !formik.isValid || formik.isSubmitting || _.isEqual(formik.values.markAnimationSetting, markAnimationSetting)) {
    return false;
  }
  return true;
}

export function MarkAnimationSetting(props: MarkAnimationProps): JSX.Element {
  const [currentMarkAnimation, setCurrentMarkAnimation] = React.useState(false);

  function handleSubmit(values: MarkAnimationField, siteUser: ISiteUserInfo) {
    UserSettings.updateMarkAnimationSetting(
      siteUser.id, values.markAnimationSetting
    ).then((result: IResult) => {
      setCurrentMarkAnimation(values.markAnimationSetting);
      ToasterService.instance.pop({ type: ToastType.Success, text: Messages.settingsUpdateSuccess() });
    }).catch((error: IError) => {
      ToasterService.instance.pop({ type: ToastType.Error, text: Messages.settingsUpdateFailure() });
    });
  }

  React.useEffect(() => {
    UserSettings.getMarkAnimationSetting(props.serverUser.id)
    .then((result: boolean) => {
      setCurrentMarkAnimation(result);
    }).catch((error: IError) => { });
  }, []);

  return (
    <Formik
      initialValues={{ markAnimationSetting: currentMarkAnimation }}
      onSubmit={(values: MarkAnimationField) => handleSubmit(values, props.siteUser)}
      enableReinitialize={true}
    >
      {
        (formik: FormikProps<MarkAnimationField>) => (
          <form onSubmit={formik.handleSubmit}>
            <table>
              <tbody className={UserSettingsStyle.tbodyNew}>
                <tr data-tb-test-id="userSettings-mark-animation">
                  <td className={UserSettingsStyle.labelTextNew}>
                    {Messages.markAnimationSettingSection()}</td>
                  <td className={UserSettingsStyle.detailsValue}>
                    {Messages.markAnimationUserSettingDetail()}</td>
                </tr>
                <tr>
                <td className={UserSettingsStyle.labelTextNew}></td>
                <td className={UserSettingsStyle.detailsValue}>
                  <FormikCheckbox
                  containerStyle={{marginLeft: 0}}
                  testId='Mark-Animation-Enabled'
                  name='markAnimationSetting'
                  disabled={props.userHasNoSiteId}
                  label={Messages.markAnimationUserSettingEnable()}/>
                </td>
                </tr>
                {
                  showButtons(formik, currentMarkAnimation) &&
                  <InlineCancelAndSaveButtons
                  testId='Mark-Animation'
                  formik={formik}
                  />
                }
               </tbody>
            </table>
          </form>
        )
      }
    </Formik>
  );

}